import React from 'react';
interface AdvertorialButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function AdvertorialButton({
  children,
  variant = 'primary',
  className = '',
  onClick,
  href = 'https://VitaleneHealth.com'
}: AdvertorialButtonProps) {
  const baseStyles: React.CSSProperties = {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    display: 'inline-block',
    textAlign: 'center',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    cursor: 'pointer',
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    textDecoration: 'none'
  };
  const primaryStyles: React.CSSProperties = {
    ...baseStyles,
    backgroundColor: '#2D9B6E',
    color: '#FFFFFF',
    border: 'none',
    padding: '18px 48px',
    fontSize: '18px',
    boxShadow: '0px 8px 24px rgba(45, 155, 110, 0.3)'
  };
  const secondaryStyles: React.CSSProperties = {
    ...baseStyles,
    backgroundColor: '#FFFFFF',
    color: '#1B4F9E',
    border: '2px solid #FFFFFF',
    padding: '16px 44px',
    fontSize: '18px',
    boxShadow: '0px 8px 24px rgba(255, 255, 255, 0.2)'
  };
  const style = variant === 'primary' ? primaryStyles : secondaryStyles;
  return <a href={href} onClick={onClick} className={`advertorial-btn advertorial-btn-${variant} ${className}`} style={style} data-id="element-302">
      {children}
    </a>;
}